module.exports = __webpack_public_path__ + "static/media/pic_premier_business_plan.802940af.jpg";